export default "__VITE_ASSET__Bmr9S1iY__"